import { Button } from '../UI/Button'
import { soundManager, SoundType } from '../domain/sound/SoundManager'

interface CloseButtonProps {
  x: number
  y: number
  width: number
  height: number
  onPress: () => void
}

export const CloseButton = (props: CloseButtonProps) => {
  return (
    <Button
      name="CloseButton"
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height}
      onPress={props.onPress}
      defaultView="close_normal"
      hoverView="close_hover"
      onPressing={() => {
        soundManager.play(SoundType.buttonClose)
      }}
      pressedView="close_click"
    />
  )
}
